module.exports = __webpack_public_path__ + "img/invoice.cbeb3952.svg";